export default __webpack_public_path__ + "apps/static/media/chrome-extension.f8b3593.blank.png";